export default "__VITE_ASSET__D4iE6$SK__"